// Notes + call-transcripts client. Thin wrappers around the
// /api/conversations/:sessionId/{notes,call-transcripts} endpoints.

import type { SessionId } from '@prakash-software/shared';
import { apiFetch } from './api';

export interface NotesPayload {
  body: string;
  updatedAt: number | null;
  updatedBy: string | null;
}

export async function getNotes(sessionId: SessionId): Promise<NotesPayload> {
  return apiFetch<NotesPayload>(
    `/api/conversations/${encodeURIComponent(sessionId)}/notes`,
  );
}

export async function putNotes(
  sessionId: SessionId,
  body: string,
): Promise<{ updatedAt: number }> {
  return apiFetch<{ updatedAt: number }>(
    `/api/conversations/${encodeURIComponent(sessionId)}/notes`,
    {
      method: 'PUT',
      body: JSON.stringify({ body }),
    },
  );
}

export interface CallTranscript {
  callId: string;
  body: string;
  provider: string;
  language: string | null;
  createdAt: number;
}

export async function listCallTranscripts(
  sessionId: SessionId,
): Promise<CallTranscript[]> {
  const res = await apiFetch<{ transcripts: CallTranscript[] }>(
    `/api/conversations/${encodeURIComponent(sessionId)}/call-transcripts`,
  );
  return res.transcripts;
}

export async function putCallTranscript(
  sessionId: SessionId,
  callId: string,
  body: string,
  provider: string = 'manual',
  language?: string,
): Promise<{ createdAt: number }> {
  return apiFetch<{ createdAt: number }>(
    `/api/conversations/${encodeURIComponent(sessionId)}/call-transcripts/${encodeURIComponent(callId)}`,
    {
      method: 'PUT',
      body: JSON.stringify({ body, provider, ...(language ? { language } : {}) }),
    },
  );
}
